// removed by extract-text-webpack-plugin
module.exports = {"dash":"styles__dash___3FSMx","defaultClass":"styles__defaultClass___1LKQX","loading":"styles__loading___33N_p","success":"styles__success___1Wa_l","cancel":"styles__cancel___2WeF5","schedule":"styles__schedule___2XZuI","reschedule":"styles__reschedule___3Hd5S","suspended":"styles__suspended___3P2bI","disapproved":"styles__disapproved___10bEi"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/Inputs/BadgeFixedVoice/styles.css
// module id = 3145
// module chunks = 0